// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-page[data-v-844a0a68]{display:flex;flex-direction:column;align-items:center;justify-content:center;text-align:center;height:100vh;padding:16px}h1[data-v-844a0a68]{margin-top:-10%;font-size:5rem;font-weight:bolder}h1[data-v-844a0a68],p[data-v-844a0a68]{color:#7a8bbc}p[data-v-844a0a68]{text-transform:uppercase;font-size:1.2rem;max-width:600px}span[data-v-844a0a68]{color:#7a8bbc;font-size:.9rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
